import React, { useEffect } from 'react'

export default function cookiePage() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
     console.log("test")
  }, []);
  
  return (
   <div>
    {/* <div id='privacinecookiepolicy360'></div> */}
   </div>
    )
}